import styled from 'styled-components';

export const LayoutHeaderComponent = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  min-height: 48px;
  border-bottom: 1px solid var(--one-color-interaction-default-intensity-low);
`;

export const ProductInfoStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  .product-name {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }
`;

export const ProductOptionsStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;
